import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {AuthenticationService} from '@app/services/authentication.service';
import { MsalService } from '@azure/msal-angular';

@Injectable({providedIn: 'root'})
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private msalService: MsalService,
        private authenticationService: AuthenticationService
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const entraIdLogged = this.msalService.instance.getActiveAccount() != null;

        if(!entraIdLogged) {
            this.authenticationService.logout();
        }

        const currentUser = this.authenticationService.currentUserValue;

        if (currentUser?.loggedIn) {
            console.log('Logged in');
            // logged in so return true
            return true;
        }

        // not logged in so redirect to login page with the return url
        this.router.navigate(['/login'], {queryParams: {returnUrl: state.url}});
        return false;
    }
}
